import { Component, OnInit,ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService} from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
declare var app;
@Component({
  selector: 'app-qc-customerconnect-detail',
  templateUrl: './qc-customerconnect-detail.component.html',
  styleUrls: ['./qc-customerconnect-detail.component.scss']
})
export class QcCustomerconnectDetailComponent extends GridBaseCase  implements AfterViewInit{
  tabsIndex = 0;
  information:any={};
  month: any = new Date();
  content:any=null;
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private native:NativeService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    private inappbrowser:InAppBrowser
  ) { super(); 
    // this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    // this.baseService.FixedSubmitBtn.configName = "ReminderDetail";
    // this.baseService.FixedSubmitBtn.isShow = true;
    // this.baseService.FixedSubmitBtn.text = "添加沟通记录";
    // this.baseService.FixedSubmitBtn.type = 1;
  }

  ngAfterViewInit
  (){

  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  tabsEvent(index){
    this.tabsIndex = index;
    this.LoadData(1);
  }
  /**
   * 打电话
   * @param event 电话号码
   */
  EventCall(event){
  this.native.GetCallPhone(event).then(fail=>{
    console.log(fail);
  }).catch(error=>{
    console.log(error);
  })
  }
  /**
   * 发短信
   * @param event 电话号码
   */
  EventMessage(event){
    let text = "";
    if(this.content){
      text=this.content.value
    }
    this.native.GetSendMsg(event,text).then(sucess=>{
     console.log(sucess);
    }).catch(error=>{
      console.log(error);
    });
  }

  LoadData(PageNumber){
    let that = this;
    that.information = that.com.GetStorageKey("customer")||{};
    if(that.information["birthday"] && that.information["birthday"].value){
      that.information["birthday"].value = that.information["birthday"].value.toString().replace(/-/g,"/");
    }
    if(that.information["phone"] && that.information["phone"].value){
      that.information["phone"].value = that.com.PhoneNum(that.information["phone"].value);
    }

    that.element = that.config[that.tabsIndex];
    console.log(that.config);
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
     
 }



 /**
  * 打开微信
  */
 Eventweixin(){
   console.log("打开微信"); 
   this.inappbrowser.create("weixin://");
 }
 /**
  * 添加沟通记录
  * @param tabindex 选项卡下标
  * @param item 当前行数据
  */
 EventClick(tabindex){
  const id = this.activaRouter.snapshot.paramMap.get('id');
  if(id){
    // this.router.navigate([this.config[tabindex].url+id.split('&')[0]]);
    this.com.Go(this.config[tabindex].url+id.split('&')[0]);
    this.com.setHistoryUrl();
  }
 }

  
 EventSubmitClick(){
   console.log(this.config);
   this.EventClick(2);
}
 
}





